export const PUBLISH_OPEN = "publish-open";
export const PREVIEW = "preview";
export const EVENT_PAGE_DELETE = "page-delete";
export const EVENT_SITE_CANVAS_DELETE = "site-canvas-delete";
export const EVENT_CANVAS_SET_DELETE = "canvas-set-delete";

export default {
  PUBLISH_OPEN,
  PREVIEW,
  EVENT_PAGE_DELETE,
  EVENT_SITE_CANVAS_DELETE,
  EVENT_CANVAS_SET_DELETE,
};
